
import { Component, Vue } from 'vue-property-decorator';
import { PROOF_STATS } from '@/config/socialProofStats';

/**
 * SocialProof Component
 *
 * Static proof line + two vetted quote cards. Renders under the
 * "Merchants run their buying on Assisty" heading owned by OnboardPricing.vue,
 * so this component does not render its own heading.
 *
 * @component
 */
@Component({})
export default class SocialProof extends Vue {
  public stats = PROOF_STATS;
}
